import { projectBookingStatus } from '@/constants'

const mixin = {
  computed: {
    projectBookingStatuses () {
      const statuses = []

      for (const prop in projectBookingStatus) {
        const id = projectBookingStatus[prop]
        let name, icon, colorClass

        switch (id) {
          case projectBookingStatus.ok:
            name = this.$t('projectBookingStatus.ok')
            icon = 'mdi-check-circle-outline'
            colorClass = 'pGreen--text'
            break
          case projectBookingStatus.planning:
            name = this.$t('projectBookingStatus.planning')
            icon = 'mdi-circle-outline'
            colorClass = 'pYellow--text'
            break
          case projectBookingStatus.cancelled:
            name = this.$t('projectBookingStatus.cancelled')
            icon = 'mdi-close-circle-outline'
            colorClass = 'pRed--text'
            break
        }

        statuses.push({
          id,
          name,
          icon,
          class: colorClass
        })
      }
      return statuses
    }
  },


  methods: {
    getProjectBookingStatusById (statusId) {
      return this.projectBookingStatuses.find(x => x.id === statusId)
    }
  }
}

export default mixin
